<script lang="ts">
  import { MatchRelevance } from '$provider/lib/apis/models/MatchRelevance';

  interface Props {
    matchRelevance: MatchRelevance;
    disabled?: boolean;
  }

  let { matchRelevance, disabled = false }: Props = $props();

  const barClasses = {
    [MatchRelevance.High]: 'high',
    [MatchRelevance.Medium]: 'medium',
    [MatchRelevance.Low]: 'low',
  };
</script>

<div class="comp-match-relevance-info">
  <div class="bars {barClasses[matchRelevance] || ''}">
    <div class="bar"></div>
    <div class="bar"></div>
    <div class="bar"></div>
  </div>

  <div class="label">
    {matchRelevance}
    <span class="text" hidden={!disabled}>(Contact your admin)</span>
  </div>
</div>

<style>
  .comp-match-relevance-info {
    display: flex;
    align-items: center;
  }
  .bars {
    display: flex;
    align-items: flex-end;
    width: 12px;
  }
  .label {
    margin-left: 6px;
    color: var(--grey-dark);
  }
  .label .text {
    font-style: italic;
    font-size: 12px;
  }
  .bars .bar {
    width: 2px;
    border-radius: 10px;
    flex-basis: 2px;
    flex-shrink: 0;
    flex-grow: 0;
    background-color: #c6c9ce;
  }
  .bars .bar:not(:first-child) {
    margin-left: 3px;
  }
  .bars .bar:nth-child(1) {
    height: 6px;
  }
  .bars .bar:nth-child(2) {
    height: 10px;
  }
  .bars .bar:nth-child(3) {
    height: 14px;
  }
  .bars.high .bar {
    background-color: var(--blue);
  }
  .bars.medium .bar:nth-child(1),
  .bars.medium .bar:nth-child(2) {
    background-color: var(--blue);
  }
  .bars.low .bar:first-child {
    background-color: var(--blue);
  }
</style>
